import React from 'react';
import classes from './style.module.css'
import { Button } from 'react-bootstrap';
import {export_table_to_csv} from '../../util/export/csv-exporter'
import {MODE_LEAGUES, MODE_MATCHES, HOME, AWAY} from "../../constants/Constants"

const ExportData = props => {

    const exportButtonClickedHandler = () => {
        let filename = props.selectionDate
        if(props.mode === MODE_LEAGUES) {
            filename = filename + "_leagues.csv"
            const html = document.querySelector("#leaguesTable");
            export_table_to_csv(html, filename)
        }else {
            let homeSuffix = ""
            let awaySuffix = ""
            if(props.home === HOME) {
                homeSuffix = "Home_as_Home"
            }else {
                homeSuffix = "Home_as_Total"
            }

            if(props.away === AWAY) {
                awaySuffix = "Away_as_Away"
            }else {
                awaySuffix = "Away_as_Total"
            }
            filename = filename + "_" + homeSuffix + "_" + awaySuffix + ".csv"
            const html = document.querySelector("#matchesTable");
            export_table_to_csv(html, filename)
        }
    }

   return (
       <div className={classes.ExportData}>
            <Button size="sm" variant="dark" onClick={exportButtonClickedHandler}>{props.label}</Button>
       </div>
   );
}

export default ExportData;